import { Component, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppValidators } from 'src/app/common/appValidators';
import { Label } from 'src/app/labels/englishLabels';

export interface ConfirmationData {
  itemName: string;
  confirmationText?: string;
  extraDisclaimer?: string;
}

@Component({
  selector: 'app-action-with-confirmation-text',
  templateUrl: './action-with-confirmation-text.component.html',
  styleUrls: ['./action-with-confirmation-text.component.scss'],
})
export class ActionWithConfirmationTextComponent {
  public textValidationControl: UntypedFormControl;
  public readonly confirmationText: string;
  public readonly defaultConfirmationText = Label.get('commonActions.deleteAction.confirmationText');
  protected confirmationAction: string;
  protected disclaimer?: string;
  protected title: string;

  constructor(
    public dialogRef: MatDialogRef<ActionWithConfirmationTextComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationData
  ) {
    this.confirmationText = data.confirmationText || this.defaultConfirmationText;
    this.textValidationControl = new UntypedFormControl('', [
      Validators.required,
      AppValidators.textValidation(this.confirmationText),
    ]);
  }

  public actionClicked(): void {
    if (this.textValidationControl.valid) {
      this.dialogRef.close(true);
    }
  }

  public cancelClicked() {
    this.dialogRef.close();
  }

  public getConfirmationText(): string {
    return this.confirmationText;
  }

  public getConfirmationAction(): string {
    return this.confirmationAction;
  }

  public getDisclaimer(): string | undefined {
    return this.disclaimer;
  }

  getTitle() {
    return this.title;
  }
}
